import { render, staticRenderFns } from "./BrandLogoCarouselTwo.vue?vue&type=template&id=fc91ea88&"
import script from "./BrandLogoCarouselTwo.vue?vue&type=script&lang=js&"
export * from "./BrandLogoCarouselTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports